import { useContext } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const CreativeBrief = ({ end }) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough, startHere} = personalization_state

    const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, creativeBrief: false}))
		startHere.set((p) => ({ ...p, show: true}))
    }
    
	const steps = [
		{
			target: '.creativeBriefFirstStep',
			title: "Start a Creative Brief",
			content: 'Begin by creating a new creative brief.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.creativeBriefSecondStep',
			title: "Project Title & Background Overview",
			content: 'Add project title and campaign background details.',
			disableBeacon: true,
			placement: "left",
			path: '/campaign/creative-brief?mode=form'
		},
		{
			target: '.creativeBriefThirdStep',
			title: "Objective & Key Message",
			content: 'Define campaign objective and key message clearly.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.creativeBriefFourthStep',
			title: "Reason to Believe & Tone and Style",
			content: 'Explain credibility and define campaign tone.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.creativeBriefFifthStep',
			title: "Deliverables & Target Audience",
			content: 'Specify deliverables and identify target audience.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.creativeBriefSixthStep',
			title: "Timeline & Call To Action",
			content: 'Set timeline and desired audience action.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.creativeBriefSeventhStep',
			title: "Save Your Creative Brief",
			content: 'Save your creative brief to finalize your campaign plan.',
			disableBeacon: true,
			placement: "top"
		}
	]

    return (
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.creativeBrief)} 
            steps={steps} 
            setter={endTour} 
            end={end}
            p_name="creativeBrief" 
            featureName="campaign"
        />
    );
}
